<script setup lang="ts">

import {useAvatar} from "@/composables/avatar";
import {ExtendedUser} from "@/types";
import {router} from "@inertiajs/vue3";

interface Props {
    user: ExtendedUser
}

const props = defineProps<Props>()

const goToProfile = () => {
    router.visit(route('users.show', {user: props.user.name}))
}
</script>

<template>
    <v-list-item
        border="sm"
        rounded="lg"
        min-height="76"
        class="mb-5"
        lines="three"
    >
        <template #prepend>
            <v-avatar
                size="36"
                class="border-sm"
            >
                <img
                    :src="useAvatar(props.user.name)"
                    alt="avatar"
                >
            </v-avatar>
        </template>
        <v-list-item-title>
            <div class="text-primary font-weight-medium">
                <span
                    class="hover-underline mr-1"
                    @click="goToProfile"
                >{{ props.user.full_name }}</span>
                <span
                    class="text-grey font-weight-light hover-underline"
                    @click="goToProfile"
                >
                    {{ props.user.name }}
                </span>
            </div>
        </v-list-item-title>
        <div
            v-if="props.user.company"
            class="text-body-2 text-black mt-1 mb-2"
        >
            {{ props.user.company }}
        </div>
        <v-list-item-subtitle
            v-if="props.user.projects_count > 0 || props.user.location"
            class="text-caption mt-1"
        >
            <span class="mr-3">{{ props.user.location }}</span>
            <v-icon class="mb-1">
                mdi-folder-outline
            </v-icon>
            {{ props.user.projects_count }}
            <v-icon class="ml-2 mb-1">
                mdi-cloud-upload-outline
            </v-icon>
            {{ props.user.uploads_count }}
        </v-list-item-subtitle>
    </v-list-item>
</template>

<style scoped>
.hover-underline:hover {
    text-decoration: underline;
    text-decoration-color: #1976d2 !important;
    cursor: pointer;
}
</style>
